import { useInfiniteQuery } from 'react-query';
import { useState } from 'react';

import { getCashRegisterSettings } from 'utils/api/baas/settings/cash-register';

/**
 * TODO:
 * - Add support for pagination
 * -- flat pages with transformPagesToList
 * -- add infinite scroll / intersection observer in SettingsCashRegister component
 */
export const useSettingsCashRegister = () => {
  const { data, error, ...others } = useInfiniteQuery({
    queryKey: ['settingsCashRegister'],
    queryFn: ({ pageParam = 1 }) => getCashRegisterSettings(pageParam),
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.next) {
        return pages.length + 1;
      }
      return undefined;
    },
  });

  const cashierList = data?.pages[0];

  // main cashier must be the first item in the list
  if (cashierList) {
    const mainCashierIndex = cashierList.findIndex((cashier) => cashier.isMain);
    if (mainCashierIndex > 0) {
      const mainCashier = cashierList[mainCashierIndex];
      // Mover el cajero principal al inicio y desplazar el resto
      cashierList.splice(mainCashierIndex, 1); // Eliminar el cajero principal
      cashierList.unshift(mainCashier); // Agregar el cajero principal al inicio
    }
  }

  return {
    data: cashierList,
    error,
    ...others,
  };
};
